import { motion } from "framer-motion";

// Subtle scroll-reveal wrapper. Fade + small upward drift only.
export const Reveal = ({ children, delay = 0, y = 16, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Section heading with diamond dividers, matching the mockup.
export const SectionHeading = ({ children, testId }) => (
  <div className="flex flex-col items-center">
    <div className="vb-divider w-full max-w-md">
      <span className="text-[10px] rotate-45 inline-block">◆</span>
    </div>
    <h2
      data-testid={testId}
      className="vb-heading text-center mt-2 sm:mt-3 text-base sm:text-xl lg:text-3xl"
    >
      {children}
    </h2>
  </div>
);
